import { render, staticRenderFns } from "./ToggleLang.vue?vue&type=template&id=00ef314b&scoped=true&"
import script from "./ToggleLang.vue?vue&type=script&lang=js&"
export * from "./ToggleLang.vue?vue&type=script&lang=js&"
import style0 from "./ToggleLang.vue?vue&type=style&index=0&id=00ef314b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef314b",
  null
  
)

export default component.exports